import { Box, SxProps, Theme } from '@mui/material';
import Button from '@mui/material/Button';
import { CallerType } from 'api/models/Common/JyrneyEnums';
import CloseableDialog from 'components/Dialogs/Dialog';
import { usePhoneState } from 'contexts/PhoneContext';
import { useState } from 'react';
import CallButton from './CallButton';

interface Props {
  number?: string
  label?: string
  id?: string
  type?: CallerType
  sx?: SxProps<Theme>
}

export const FallbackButton = (props: Props) => {
  const { number, label, id, type, sx } = props
  const { device } = usePhoneState()
  const [isContactDetailsVisible, setContactDetailsVisible] = useState(false)

  if (device && id && type) {
    return <CallButton id={id} type={type} sx={sx} />
  }

  return (
    <>
      <Button
        sx={[
          { margin: 0, padding: '6px 12px' },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        onClick={async () => {
          setContactDetailsVisible(true)
        }}
      >
        Call
      </Button>
      <CloseableDialog
        title="Contact Details"
        isVisible={isContactDetailsVisible}
        setIsVisible={setContactDetailsVisible}
        paperProps={{ sx: { width: '18%' } }}
      >
        <Box sx={{ typography: 'subtitle1' }}>{label || ''}</Box>
        <Box sx={{ typography: 'subtitle1' }}>{number || ''}</Box>
      </CloseableDialog>
    </>
  )
}

export default FallbackButton
